import { Loader } from "@circle-react-uikit/Loader";
import type { ReactNode } from "react";
import { createContext, useEffect, useMemo, useState } from "react";

import { loadTranslations } from "@/i18n-js/instance";

interface I18nContextValue {
  isReady: boolean;
}

const I18nContext = createContext<I18nContextValue>({ isReady: false });
I18nContext.displayName = "I18nContext";

export interface I18nProviderProps {
  children: ReactNode;
}

export const I18nProvider = ({ children }: I18nProviderProps) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    void loadTranslations().then(() => setIsReady(true));
  }, []);

  const contextValue = useMemo(() => ({ isReady }), [isReady]);

  if (!isReady) {
    return <Loader center variant="fullscreen" />;
  }

  return (
    <I18nContext.Provider value={contextValue}>{children}</I18nContext.Provider>
  );
};
